<template>
  <div class="dictionary clearfix">
    <div class="dictionary-left">
      <el-row class="dictionary-row">
        <el-col :span=18>
          <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt=""
              style="vertical-align:middle;"></span>
          <span style="height:54px;line-height:54px;font-size:16px;margin-left:10px">服务管理</span>
        </el-col>
        <el-col :span=3 :offset=3>
          <i class="el-icon-plus add_icon" @click="addCata" />
        </el-col>
      </el-row>
      <el-row style="width:90%;margin:10px auto;">
        <el-tree :data="treeList" node-key="id" :default-expand-all="false" :expand-on-click-node="false"
          @node-click="handleNodeDictionary" :props="defaultProps">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button v-if="data.domid == 'f'" type="text" size="mini" @click="() => appendDictionary(data)">
                <img src="@/assets/beadhouse/bigjia.png" alt="" class="vertical-align-cursor">
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-row>
    </div>
    <div class="dictionary-right">
      <el-row>
        <el-row class="dictionary-row">
          <el-col :span=2>
            <span class="dictionary-row-span-ml"><img src="@/assets/beadhouse/juxing.png" alt=""
                style="vertical-align:middle;"></span>
          </el-col>
          <el-col :span=4 :offset=9 style='font-size:16px'>服务管理列表</el-col>
          <el-col :span=2 :offset=7 align=center>
          </el-col>
        </el-row>
      </el-row>
      <el-row style="margin-top:10px;">
        <!--表格内容栏-->
        <el-table :data="tableData" :header-cell-style="tableHeaderColor" style="width: 100%">
          
          <el-table-column prop="picture" label="主图" width="60" align=center>
            <template slot-scope="scope">
                <el-image :src="scope.row.picture" :preview-src-list="[scope.row.picture]" class="imgSize2"/>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="服务项目" min-width="100" align=center></el-table-column>
          <el-table-column prop="label" label="标签" min-width="100" show-overflow-tooltip align=center></el-table-column>
          <el-table-column prop="remark" label="描述" min-width="100" show-overflow-tooltip align=center></el-table-column>
          <el-table-column prop="minTime" label="最低服务时长(分)" min-width="80" align=center></el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="80" align=center></el-table-column>
          <el-table-column prop="paymentMethod" label="收费方式" width="80" :formatter="formatType" align=center>
          </el-table-column>
          <el-table-column label="操作" width="80" align=center>
            <template slot-scope="scope">
              <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="imgSize"
                @click="deleteRow(scope.$index, scope.row)">
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="total"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </el-row>

      </el-row>
    </div>
    

    <!-- 新增和修改服务类别的dialog模态框-->
     <!-- 商品弹窗 -->
     <el-dialog title="新增服务项目" width="800px" :visible.sync="dialogVisibleForm" :close-on-click-modal="false">
     <el-form :model="serviceCategoryForm" label-width="140px" ref="dataForm" label-position="right">
         <el-row type="flex" justify="center">
             <el-col>
                 <el-row>
                     <el-col :span="12">
                         <el-form-item label="项目名称:" prop="name">
                             <el-input v-model.trim="serviceCategoryForm.name" clearable
                                 style="width: 200px;"
                                 placeholder="请输入项目名称"></el-input>
                         </el-form-item>
                     </el-col>
                     <el-col :span="12">
                         <el-form-item label="项目描述:" prop="description">
                             <el-input v-model.trim="serviceCategoryForm.description" clearable
                                 style="width: 200px;"
                                 placeholder="请输入项目名称"></el-input>
                         </el-form-item>
                     </el-col>
                 </el-row>

                 <el-row>
                     <el-col :span="12">
                         <el-form-item label="项目图片:" prop="imgsCode">
                             <el-upload class="avatar-uploader" action="string" accept="image/png, image/jpeg"
                                 :show-file-list="false" list-type="picture-card" :before-upload="beforeUpload"
                                 :http-request="upload">
                                 <i v-if="serviceCategoryForm.picture" class="el-icon-close closeIcon" style="color: #000"
                                     @click="closeImg"></i>
                                 <img style="width: 100%; height: 100%" v-if="serviceCategoryForm.picture"
                                     :src="serviceCategoryForm.picture" class="avatar" />
                                 <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                             </el-upload>
                         </el-form-item>
                     </el-col>

                     <el-col :span="12">
                         <el-form-item label="是否启用:" prop="catalogId">
                             <el-select
                                 style="width: 200px;"
                                 v-model="serviceCategoryForm.isUse">
                                 <el-option
                                     label="未启用"
                                     value="0">未启用
                                 </el-option>
                                 <el-option
                                     label="已启用"
                                     value="1">已启用
                                 </el-option>
                             </el-select>
                         </el-form-item>
                     </el-col>
                 </el-row>

                 <el-row>
                     <el-col :span="12">
                         <el-form-item label="服务类别:" prop="catalogId">
                             <el-select
                                 style="width: 200px;"
                                 v-model="serviceCategoryForm.catalogId">
                                 <el-option
                                     v-for="item in catalogList"
                                     :key="item.id"
                                     :label="item.dictName"
                                     :value="item.id">
                                 </el-option>
                             </el-select>
                         </el-form-item>
                     </el-col>
                    <el-col :span="12">
                      <el-form-item label="项目标签:" prop="label">
                          <el-input v-model.trim="serviceCategoryForm.label" clearable
                              style="width: 200px;"
                              placeholder="请输入项目标签"></el-input>
                      </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="收费方式:" prop="paymentMethod">
                            <el-select
                                style="width: 200px;"
                                v-model="serviceCategoryForm.paymentMethod">
                                <el-option label="次" value="0">次</el-option>
                                 <el-option label="小时" value="1">小时</el-option>
                                 <el-option label="分钟" value="2">分钟</el-option>
                                 <el-option label="天" value="3">天</el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                   <el-col :span="12">
                     <el-form-item label="服务时长:" prop="minTime">
                         <el-input v-model.trim="serviceCategoryForm.minTime" clearable
                             style="width: 200px;"
                             placeholder="请输入最低服务时长"></el-input>
                     </el-form-item>
                   </el-col>
               </el-row>

               <el-row>
                <el-col :span="12">
                    <el-form-item label="单价:" prop="unitPrice">
                      <el-input v-model.trim="serviceCategoryForm.unitPrice" clearable
                         style="width: 200px;"
                         placeholder="请输入单价"></el-input>
                        
                    </el-form-item>
                </el-col>
               <el-col :span="12">
                 <el-form-item label="备注:" prop="remark">
                     <el-input v-model.trim="serviceCategoryForm.remark" clearable
                         style="width: 200px;"
                         placeholder="请输入备注"></el-input>
                 </el-form-item>
               </el-col>
           </el-row>
                 

             </el-col>
         </el-row>
     </el-form>
     <div slot="footer" class="dialog-footer" align="center">
         <el-button @click.native="dialogVisible = false">取消</el-button>
         <el-button type="primary" @click.native="submitForm">确定</el-button>
     </div>
 </el-dialog>

  </div>
</template>
<script>
import KtTable from "@/components/KtTable"
import KtButton from "@/components/KtButton"
export default {
  name: 'Dictionary',
  components: { KtTable, KtButton, },
  data() {
    return {
      operation: true,//默认是true  点击dialog显示的是新字典的dialog模态框
      size: 'medium',//按钮的尺寸
      id: "",//当前菜单的id  默认显示第一个tree的菜单  
      pid: "",//父级的id
      catalogId:null,
      specialName:null,
      treeList: [
      ],//服务项目树
      serviceCategoryForm: {},
      catalogList:[],
      treeOneList: [],
      treeTwoList: [],
      treeThreeList: [],
      treeFourList: [],
      defaultProps: {
        children: 'children',
        label: 'dictName'
      },
      //新增和修改字典的dialog模态框的配置
      dialogVisibleDictionaryForm: false,//dialog模态框默认为隐藏
      dictionaryFormLoading: false,//新增和修改的确定按钮加载的loading  默认为false 不加载 
      dictionaryForm: {},//新增字典数据源
      serviceCategory: {
        serviceType: "服务类别",
        serviceItem: "服务项目",
        basicInfo: "基本信息",
        addServive: "新增服务类别",
        editService: "修改服务类别",
        addServiceItem: "新增服务项目",
        editServiceItem: "修改服务项目",
        serviceName: "服务名称：",
        categoryDescription: "类别描述：",
        itemList: "项目列表",
        serviceCategory: "序号",
        projectName: "项目名称",
        itemSmallClass: "项目小类",
        projectCost: "项目费用",
        chargeMethod: "收费方式",
        timeRequired: "所需时间",
        projectIntroduction: "项目介绍",
        enterServiceType: "请输入服务类别",
        ServiceDescription: "类别描述",
        enterServiceDescription: "请输入服务描述",
        addItem: "新增项目",
        editItem: "修改项目",
        belongCategory: "所属类别",
        enterBelongCategory: "请选择所属类别",
        enterItemSmallClass: "请输入项目小类",
        enterProjectCost: "请输入费用项目",
        enterTimeRequired: "请输入所属时间",
        enterProjectIntroduction: "请输入项目介绍",
        notEmpty: "不能为空"
      }, //引入 lang 里面的字符串资源
      dialogVisibleForm: false,
      dictionaryFormRules: {//验证的匹配规则

      },
      loading: false,//表格加载的loading
      allData: [],
      tableData: [
      ],
      //分页
      currentPage: 1, //初始页
      pageNum: 1, //页码
      total:0,
      pageSize: 10, //每页显示的条数
      totalDataNumber: 4, //数据的总数,
    }
  },
  methods: {
    
    formatType: function (row) {
      if(row.paymentMethod == 0){
        return "元/次"
      }else if(row.paymentMethod == 1){
        return "元/小时"
      }else if(row.paymentMethod == 2){
        return "元/分钟"
      }else if(row.paymentMethod == 2){
        return "元/天"
      }else{
        return "元/月"
      }
    },
    addCata() {
      this.$nextTick(() => {
        if (this.$refs.serviceCategoryForm != undefined) {
          this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
        }
      });

      

    },
    /* 
      关闭新增和修改的dialog清除验证
    */
    closeServiceCategoryFormDialog() {
      this.$refs.serviceCategoryForm.resetFields(); //移除校验结果并重置字段值
    },
    /* 
        关闭新增和修改服务的dialog
    */
    closeDictionaryDialog() {
      this.$nextTick(() => {
        if (this.$refs.dictionaryForm) {
          this.$refs.dictionaryForm.resetFields();//移除校验结果并重置字段值
        }
      })
    },
    /* 
      查询服务类别树
    */
    getTree() {
      this.$postJson('omc/serviceProject/listServiceCatalog', { pageNum:1 ,pageSize: 99, isUse:1 }).then(res => {
        if (res.code == 200) {
          let treeList = [];
          res.result.forEach(item => {
            let children = [];
            console.log(item.serviceProjectCatalogList);
            if(item.serviceProjectCatalogList!=null && item.serviceProjectCatalogList.length>0){
              item.serviceProjectCatalogList.forEach(item2=>{
                children.push({
                  id: item2.id,
                  dictName: item2.name,
                  description: item2.description,
                  remark: item2.remark,
                  domid: "g",
                })
              })
            }
            treeList.push({
              id: item.id,
              dictName: item.name,
              description: item.description,
              remark: item.remark,
              domid: "f",
              children: children
            })
          })
          this.treeList = treeList;
          this.allData = res.result;
          this.specialName = treeList[0].dictName;
          this.catalogId = null;
          this.queryServiceProject();
        }
      })
    },
    queryServiceProject(){
      this.$postJson('omc/serviceProject/queryProjectList', 
      { pageNum:this.pageNum ,pageSize: 10, isUse:1,catalogId:this.catalogId,specialName:this.specialName })
      .then(res=>{
        this.tableData = res.result.list;
        this.total = Number(res.result.total)
      })
    },
    // 删除图片
    closeImg(e) {
        e.stopPropagation();
        this.serviceCategoryForm.picture = undefined;
    },
    //提交添加类别
    submitForm() {
        let url = "omc/serviceProject/addProject";
        let params = this.serviceCategoryForm;
        params.groupId = Number(sessionStorage.getItem("groupId"));
        this.$postJson(url, params).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.operation = true; //初始化数据
            this.dialogVisibleForm = false; //初始化数据
            this.$message({ message: res.message, type: "success" });
            this.queryServiceProject();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
    },
    /* 
      点击tree树
    */
    handleNodeDictionary(data, node, vuecomponent) {
      if(data.domid == 'g'){
        this.specialName = null;
        this.catalogId = data.id;
        this.queryServiceProject();
      }else if(data.domid == 'f'){
        this.specialName = data.dictName;
        this.catalogId = null;
        this.queryServiceProject();
      }
    },
    /* 
      新增服务 弹出dialog模态框
    */
    appendService(data) {
      this.dialogVisibleDictionaryForm = true;//dialog模态框打开
    },

    /* 
      新增小项 弹出dialog模态框
    */
    appendDictionary(data) {
      console.log(data);
      this.serviceCategory.title = "新增服务项目";
      this.dialogVisibleForm = true;
      this.catalogList = data.children,

      this.serviceCategoryForm = {
        name: "",
        description: "",
        picture: null,
        specialName:data.dictName,
        label: "",
        isUse: "",
        catalogType: "",
        catalogId:"",
        paymentMethod: "",
        unitPrice: "",
        minTime: "",
        remark: ""
      };

    },
    /* 
        新增 和  修改 服务提交数据
    */
    submitDictionaryForm() {
      this.$refs.dictionaryForm.validate((valid) => {
        if (valid) {
          let params = {};
          params = Object.assign({}, this.dictionaryForm);//拷贝需要提交的数据源
          this.dictionaryFormLoading = true;//确定按钮loadin为true;
          let url = "omc/service/addSecondLevel";
          if (params.id != null) {
            url = "omc/service/updateSecondLevel";
            params.name = params.secondLevelName;
            params.id = Number(params.id);
            delete params.firstLevelId;
            delete params.secondLevelName;
          }
          this.$postJson(url, params).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.operation = true;//重置状态为true
            this.dictionaryFormLoading = false;//loading隐藏
            this.dialogVisibleDictionaryForm = false;//dialog模态框关闭
            this.getTree();//刷新字典树
            this.$refs.dictionaryForm.resetFields();//移除校验结果并重置字段值
          })
        }
      })
    },

    /* 
      删除服务 弹出dialog模态框
    */
    removeDictionary(node, data) {
      console.log(node, data);
      console.log(node, data);
      this.$confirm('确认删除服务类别吗？', '删除类别', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$postForm(this.ports.dictionary.deleteDictionary + data.id).then((res) => {
          console.log(res);
          this.getTree();//刷新字典树
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
    /* 
      表格中的编辑
    */
    EditRow(index, row) {
      this.dictionaryForm = {
        id: row.id,
        firstLevelId: row.firstLevelId,
        secondLevelName: row.secondLevelName,
        remark: row.remark,
        name:row.name,
        groupId: sessionStorage.getItem("groupId")
      }
      this.operation = false;//修改的
      this.dialogVisibleDictionaryForm = true;//dialog模态框打开
    },

    /* 
      表格中的删除
    */
    deleteRow(index, row) {
      console.log(index, row);
      if (row.id != 1 && row.id != 2) {
        this.$confirm('确认删除吗？', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.$postForm(this.ports.dictionary.deleteDictionary + row.id).then((res) => {
            console.log(res);
            this.getTree();//刷新
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
      } else {
        this.$message({ message: "此字典项不能删除", type: "error" });
      }
    },
    //上传图片
    upload(param) {
            var fileObj = param.file;
            if (fileObj != undefined) {
                // FormData 对象
                var form = new FormData();
                // 文件对象
                form.append("file", fileObj);
                form.append("fileType", "picture");
                form.append("bucketName", "cmny-oss");
                console.log(form);
                this.$postFormData("dmc/file/uploadFile", form).then((res) => {
                    if (res.code == 200) {
                        this.serviceCategoryForm.picture = res.result;
                        this.$message({ message: res.message, type: "success" });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message,
                        });
                    }
                });
            }
        },

        /* 
          图片验证
        */
        beforeUpload(file) {
            console.log(file);
            let isPNG = false;
            file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isPNG) {
                this.$message.error("上传图片格式不能是 gif 格式");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB");
            }
            return isPNG && isLt2M;
        },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // 改变每页显示的条数
      this.PageSize = val;
      //刷新列表
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      //刷新列表
      this.queryServiceProject();
    },

    /* 
      修改table tr行的背景色
    */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },

    /* 
      修改table header的背景色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
  },
  created() {

  },
  mounted() {
    this.getTree();
  },
}
</script>
<style lang="scss" scoped>
.add_icon {
  color: #0b80c0;
  font-size: 20px;
  margin-right: 12px;
  font-weight: bold;
  margin-top: 3px;
}

.dictionary {
  width: 100%;
  height: 98%;
  margin-top: 5px;
  background: #FEFEFE;

  .dictionary-left {
    float: left;
    width: 22%;
    height: 100%;
    border: 1px #bee1f4 solid;
    margin-right: 2%;
    box-sizing: border-box;
    min-height: 500px;
  }

  .dictionary-right {
    float: right;
    width: 74%;
    height: 100%;
    margin-right: 2%;
    box-sizing: border-box;
  }

  .dictionary-row {
    height: 54px;
    line-height: 54px;
    background-color: #bee1f4;
    color: #6f7075;
    font-weight: 500;
    border: 1px #bee1f4 solid;
  }

  .dictionary-row-span-ml {
    height: 54px;
    line-height: 54px;
    margin-left: 10px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  .vertical-align-cursor {
    vertical-align: middle;
    cursor: pointer;
    width: 15px;
    height: 15px;
  }

  .imgSize {
    vertical-align: middle;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }

  
  .imgSize2 {
    vertical-align: middle;
    width: 32px;
    height: 32px;
  }
}

.closeIcon {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 130px;
  font-size: 16px;
}
</style>
